import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../default-cloud-graph-remote-link-entity-ati';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { PagerDutyIcon } from './icon';
import { PagerDutySearchResultIcon } from './search-result-icon';

export const pagerDutyConfig: ThirdPartyConfig = {
	displayName: 'PagerDuty',
	id: 'pagerduty',
	resourceType: 'smartlinks-connector-pagerduty',
	icon: get3PLogo(PagerDutyIcon, 'PagerDuty', 'medium'),
	searchResultIcon: get3PLogo(PagerDutySearchResultIcon, 'PagerDuty', 'large'),
	integrationAri: 'ari:cloud:platform::integration/pagerduty',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
